import axios, { AxiosError } from "axios";
import config, { BASE_URL } from "../config/config";

const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: config.requestTimeout,
});

apiClient.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      return Promise.reject(error.response.data);
    } else if (error.request) {
      return Promise.reject({ message: "No response from server" });
    } else {
      return Promise.reject({ message: error.message });
    }
  }
);

export const get = async <T>(
  url: string,
  params: Record<string, any> = {}
): Promise<T> => {
  try {
    const response = await apiClient.get<T>(url, params);
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    throw new Error(axiosError.message || "An error occurred");
  }
};

export const post = async (url: string, data: any) => {
  const response = await apiClient.post(url, data);
  return response.data;
};

export default apiClient;
